// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3irnQ","col":"styles_col__2KANi"};